export default __webpack_public_path__ + "static/media/O-150.2cc5b48c.png";